import axios from "axios";

export const BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://feedback-sbil.onrender.com"
    : "http://localhost:8000";

export const API = axios.create({
  baseURL: BASE_URL,
});
